module.exports = __webpack_public_path__ + "img/16-2.2ded6103.jpg";